<template>
  <div>
    <div
      class="btn-wrapper d-flex justify-content-md-end justify-content-center"
    >
      <button
        class="btn btn-outline-primary wizard-btn prev-btn"
        @click="previous"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        {{ $t("global.return") }}
      </button>
      <button class="btn btn-primary wizard-btn next-btn" @click="nextStep">
        {{ $t("global.save") }}
      </button>
    </div>
    <div class="card card-small mb-4 mt-3">
      <div class="card-body">
        <div class="py-2 px-3">
          <h5 class="mb-4">{{ $t("days.off.request.step.five.title") }}</h5>
          <div class="row">
            <div class="col-lg-6">
              <recapitulatif-days-off
                :request="formatedRequest"
                :show-last-two="false"
              />
            </div>
            <div class="col-lg-6">
              <div
                class
                v-if="
                  request.urgent || request.type === daysOffType.OTHER.value
                "
              >
                <div v-if="request.urgent">
                  <h6 style="font-weight: 600">Motif d'urgence :</h6>
                  <span>{{ request.motifUrgent }}</span>
                </div>
                <div class v-if="request.type === daysOffType.OTHER.value">
                  <h6>Motif de demande :</h6>
                  <span>{{ request.motifOther }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import daysOffType from '../../../data/daysOff/daysOffType.js';
import RecapitulatifDaysOff from '../RecapitulatifDaysOff';
import TimeUtils from '../../../utils/TimeUtils';

export default {
  name: 'StepFive',
  components: { RecapitulatifDaysOff },
  props: ['user', 'request'],
  data() {
    return {
      daysOffType,
    };
  },
  computed: {
    formatedRequest() {
      return {
        urgent: this.request.urgent,
        type: this.request.type,
        dateFrom: this.request.dateFrom,
        dateTo: this.request.dateTo,
        dateFromHalf: TimeUtils.isFullDay(this.request.dateFrom) - 1,
        dateToHalf: TimeUtils.isFullDay(this.request.dateTo) - 1,
      };
    },
  },
  methods: {
    previous() {
      this.$emit('input', null);
    },
    nextStep() {
      this.$emit('input', true);
    },
  },
};
</script>

<style lang="scss">
.underline {
  text-decoration: underline;
}
.five {
  p {
    margin: 0;
  }
  .d-flex {
    padding: 1rem;
    align-content: center;
    align-items: center;
  }
}
.card {
  position: relative;
  background-color: transparent;
}
.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}
</style>
